<template>
    <div id="#app">
      <full-page :options="options" id="fullpage" ref="fullpage">
        <div class="section"><section1 @open="openDrawer"></section1></div>
        <div class="section"><section2 @open="openDrawer"></section2></div>
        <div class="section"><section3 @open="openDrawer"></section3></div>
        <div class="section"><section4 @open="openDrawer"></section4></div>
        <div class="section"><section5 @open="openDrawer"></section5></div>
        <div class="section"><section6 @open="openDrawer"></section6></div>
        <div class="section"><section7 @open="openDrawer"></section7></div>
        <div class="section"><section8 @open="openDrawer"></section8></div>
      </full-page>
      <popup :visiable="visiable" @close="closeDrawer"></popup>
    </div>
  </template>
  
  <script>
  import Popup from "./components/Popup.vue";
  import Section1 from "./Section1.vue";
  import Section2 from "./Section2.vue";
  import Section3 from "./Section3.vue";
  import Section4 from "./Section4.vue";
  import Section5 from "./Section5.vue";
  import Section6 from "./Section6.vue";
  import Section7 from "./Section7.vue";
  import Section8 from "./Section8.vue";
  export default {
    name: "Home",
    components: {
      Popup,
      Section1,
      Section2,
      Section3,
      Section4,
      Section5,
      Section6,
      Section7,
      Section8,
    },
    data() {
      return {
        direction: "rtl",
        visiable: false,
        options: {
          licenseKey: "YOUR_KEY_HERE",
          afterLoad: this.afterLoad,
          scrollOverflow: true,
          scrollBar: false,
          menu: "#menu",
          navigation: false,
          navigationColor: "#fff",
          anchors: [
            "page1",
            "page2",
            "page3",
            "page4",
            "page5",
            "page6",
            "page7",
            "page8",
          ],
          sectionsColor: [
            // "#41b883",
            // "#ff5f45",
            // "#0798ec",
            // "#fec401",
            // "#1bcee6",
            // "#ee1a59",
            // "#2c3e4f",
            // "#ba5be9",
            // "#b4b8ab",
          ],
        },
        swiperOptions: {
          pagination: {
            el: ".swiper-pagination", //与slot="pagination"处 class 一致
            clickable: true, //轮播按钮支持点击
          },
        },
      };
    },
    created() {
      document.title = "INDIBA中国官方网站";
    },
    mounted() {
      window.onresize = () => {
        const fullpageRef = this.$refs.fullpage;
        if (fullpageRef && typeof fullpageRef.build === "function") {
          fullpageRef.build();
        }
      };
    },
    methods: {
      afterLoad() {
        console.log("After load");
      },
  
      openDrawer() {
        this.visiable = true;
      },
  
      closeDrawer() {
        this.visiable = false;
      },
  
      // addSection (e) {
      //   e.preventDefault()
      //   var newSectionNumber = document.querySelectorAll('.fp-section').length + 1
  
      //   // creating the section div
      //   var section = document.createElement('div')
      //   section.className = 'section'
      //   section.innerHTML = `<h3>Section ${newSectionNumber}</h3>`
  
      //   // adding section
      //   document.querySelector('#fullpage').appendChild(section)
  
      //   // creating the section menu element
      //   var sectionMenuItem = document.createElement('li')
      //   sectionMenuItem.setAttribute('data-menuanchor', 'page' + newSectionNumber)
      //   sectionMenuItem.innerHTML = `<a href="#page${newSectionNumber}">Section${newSectionNumber}</a>`
  
      //   // adding it to the sections menu
      //   var sectionsMenuItems = document.querySelector('#menu')
      //   sectionsMenuItems.appendChild(sectionMenuItem)
  
      //   // adding anchor for the section
      //   this.options.anchors.push(`page${newSectionNumber}`)
  
      //   // we have to call `update` manually as DOM changes won't fire updates
      //   // requires the use of the attribute ref="fullpage" on the
      //   // component element, in this case, <full-page>
      //   // ideally, use an ID element for that element too
      //   this.$refs.fullpage.build()
      // },
      // removeSection () {
      //   var sections = document.querySelector('#fullpage').querySelectorAll('.fp-section')
      //   var lastSection = sections[sections.length - 1]
  
      //   // removing the last section
      //   lastSection.parentNode.removeChild(lastSection)
  
      //   // removing the last anchor
      //   this.options.anchors.pop()
  
      //   // removing the last item on the sections menu
      //   var sectionsMenuItems = document.querySelectorAll('#menu li')
      //   var lastItem = sectionsMenuItems[sectionsMenuItems.length - 1]
      //   lastItem.parentNode.removeChild(lastItem)
      // },
      // toggleNavigation () {
      //   this.options.navigation = !this.options.navigation
      // },
      // toggleScrollbar () {
      //   console.log('Changing scrollbar...')
      //   this.options.scrollBar = !this.options.scrollBar
      // }
    },
  };
  </script>
  
  <style lang="less">
  .header {
    position: absolute;
    height: 2rem;
    border: 1px solid red;
  }
  .navbar-wrapper {
    width: 295px;
    height: 100%;
    background: #262626;
    color: #fff;
  }
  
  .page1 {
    height: 100%;
    background: url(../../assets/home/mobile/first_bg01.png);
    background-size: 100% 100%;
  }
  </style>
  